// Set up levels array and set default and member levels
//
// IMPORTANT NOTE:
// LEVEL NUMBERING IS BASED ON LEVEL ARRAY INDEXES,
// WHICH ARE IN RANKED ORDER, UNLIKE LEVEL API IDs

import member from "../../session";

let levels = [
  {
    id: "0",
    name: "Complimentary",
    priceLabel: "Free",
    priceValue: 0,
    description: `<p>
    You have been granted a complimentary membership to Long Now for
    your personal contribution to long-term thinking. Thank you for
    being a part of our story.</p><p>If you would like to further your support
    of Long Now, consider making a <a href="/donate">donation</a>.</p><p>To transition to an annual paid membership, please 
    <a href="mailto:membership@longnow.org">
      contact the membership team.
    </a>
  </p>`,
  },
  {
    id: "7",
    name: "Bronze",
    priceLabel: "$8/month",
    priceValue: 8,
    description: `<p>Stay connected with this basic level of membership. Bronze Members receive live video streams of our monthly talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock.</p>`,
  },
  {
    id: "1",
    name: "Stainless Steel",
    priceLabel: "$12/month",
    priceValue: 12,
    description: `<p>Our most popular membership level. Stainless Steel Members receive complimentary tickets to our monthly talks in San Francisco and priority access to buy tickets to events at The Interval. They also receive live video streams of our talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock.</p>`,
  },
  {
    id: "2",
    name: "Monel",
    priceLabel: "$30/month",
    priceValue: 30,
    description: `<p>An intermediate membership level for those who wish to elevate their support for long-term thinking. Monel Members receive a copy of our book, <em>Long Now: Works in Progress</em>. They also receive complimentary tickets to our monthly talks in San Francisco and priority access to buy tickets to events at The Interval, live video streams of our talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock.</p>`,
  },
  {
    id: "3",
    name: "Tungsten",
    priceLabel: "$80/month",
    priceValue: 80,
    description: `<p>A higher level of monthly membership. Tungsten Members receive priority ticketing for special events, and Brian Eno's album <i>January 07003: Bell Studies for the Clock of the Long Now</i>. They also receive a copy of our book, <em>Long Now: Works in Progress</em>, complimentary tickets to our monthly talks in San Francisco and priority access to buy tickets to events at The Interval, live video streams of our talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock.</p>`,
  },
  {
    id: "4",
    name: "Equation of Time Cam",
    priceLabel: "$2,500/year",
    description: `<p>A special membership level inspired by a unique artifact from The Clock of the Long Now. Members at this level will receive a limited-edition Equation of Time Cam machined from solid bronze. This distinctive component was designed to ensure accurate timekeeping across the next 10,000 years. </p> <p>They also receive priority ticketing for special events, Brian Eno’s album <i>January 07003: Bell Studies for the Clock of the Long Now</i>, a copy of our book, <em>Long Now: Works in Progress</em>, complimentary tickets to our monthly talks in San Francisco and priority access to buy tickets to events at The Interval, live video streams of our talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock.</p>`,
  },
  {
    id: "5",
    name: "10,000 Year",
    priceLabel: "One-time donation of $10,000",
    description: `<p>A membership designed to last as long as The Clock. Please <a href="mailto:donate@longnow.org?subject=10,000 Year Membership Request" target="_blank" rel="noopener">email donate@longnow.org</a> if you are interested in being a 10,000 Year Member of The Long Now Foundation. </p> <p> Among other things, members at this level will receive priority ticketing for special events, Brian Eno's album <i>January 07003: Bell Studies for the Clock of the Long Now</i>, a copy of our book, <em>Long Now: Works in Progress</em>, complimentary tickets to our monthly talks in San Francisco and priority access to buy tickets to events at The Interval, live video streams of our talks, our regular member newsletter, and a stainless steel membership card etched with their unique member number. All Long Now members will be among first to hear about visits to the Clock. </p>`,
  },
];
const defaultLevel = "2";
const memberLevel = member
  ? levels.findIndex((x) => x.name === member.level)
  : null;
export { levels, defaultLevel, memberLevel };
